"use client";

import { Info } from "lucide-react";

interface CitationTextProps {
  text: string;
  citations: readonly { badgeLabel: string; detail: string }[];
  expandedBadge: string | null;
  onBadgeClick: (label: string) => void;
}

export function CitationText({
  text,
  citations,
  expandedBadge,
  onBadgeClick,
}: CitationTextProps) {
  const parts = text.split(/(\[[^\]]+\])/g);
  return (
    <>
      {parts.map((part, i) => {
        const match = /^\[([^\]]+)\]$/.exec(part);
        if (match) {
          const label = match[1] ?? "";
          const hasCitation = citations.some((c) => c.badgeLabel === label);
          if (hasCitation) {
            return (
              <button
                key={i}
                onClick={() => onBadgeClick(label)}
                className={[
                  // py-1 -my-1: grows the tap target to the ruled 24px web floor
                  // while the negative margin keeps the prose line-height it sits
                  // inside unchanged. Measured 20px before this — the badge is how
                  // a customer reaches the evidence behind an AI claim, so it is
                  // one of the last controls that should be hard to hit.
                  "inline-flex items-center gap-0.5 rounded px-1.5 py-1 -my-1 text-xs font-semibold mx-0.5 transition-colors duration-fast",
                  expandedBadge === label
                    ? "bg-brand-primary-hover text-white"
                    : "bg-brand-primary/10 text-brand-primary-text hover:bg-brand-primary/20",
                ].join(" ")}
                aria-pressed={expandedBadge === label}
                aria-label={`Citation: ${label}`}
              >
                <Info size={10} aria-hidden />
                {label}
              </button>
            );
          }
        }
        return <span key={i}>{part}</span>;
      })}
    </>
  );
}
